export const getAuthToken = () => {
  if (localStorage.getItem("tokenInfo")) {
    return localStorage.getItem("tokenInfo");
  }
  return "";
};

export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem("tokenInfo", `Bearer ${token}`);
  }
};

export const removeAuthToken = () => {
  localStorage.clear("tokenInfo");
};
export const setWalletAddress = (token) => {
  localStorage.setItem("adminWalletAddress", token);
}
export const getWalletAddress = () => {
  if (localStorage.getItem('adminWalletAddress')) {
    return localStorage.getItem('adminWalletAddress')
  }
  return '';
}